export default function setCityyErrAction(cityError) {
    return {
        type: 'SET_CITY_ERR',
        payload: cityError
    }
}